export const adjustLightness = (hex: string, intensity: number = 0): string => {
  const {h, s, l} = hexToHSL(hex);
  return hslToHex(h, s, l + intensity);
};

const hexToHSL = (hex: string): { h: number; s: number; l: number } => {
  const red = parseInt(hex.slice(1, 3), 16) / 255;
  const green = parseInt(hex.slice(3, 5), 16) / 255;
  const blue = parseInt(hex.slice(5, 7), 16) / 255;
  const max = Math.max(red, green, blue);
  const min = Math.min(red, green, blue);
  let hue = 0, saturation = 0;
  const light = (max + min) / 2;

  if (max !== min) {
    const delta = max - min;
    saturation = light > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch (max) {
      case red:
        hue = (green - blue) / delta + (green < blue ? 6 : 0);
        break;
      case green:
        hue = (blue - red) / delta + 2;
        break;
      case blue:
        hue = (red - green) / delta + 4;
        break;
    }
    hue /= 6;
  }

  return {
    h: hue * 360,
    s: saturation * 100,
    l: light * 100
  };
};

const hslToHex = (hue: number, saturation: number, light: number): string => {
  saturation /= 100;
  light /= 100;
  const tone = (node: number) => (node + hue / 30) % 12;
  const alpha = saturation * Math.min(light, 1 - light);
  const color = (node: number) => light - alpha * Math.max(-1, Math.min(tone(node) - 3, Math.min(9 - tone(node), 1)));
  const red = Math.round(color(0) * 255);
  const green = Math.round(color(8) * 255);
  const blue = Math.round(color(4) * 255);
  const redHex = red.toString(16).padStart(2, '0').toUpperCase();
  const greenHex = green.toString(16).padStart(2, '0').toUpperCase();
  const blueHex = blue.toString(16).padStart(2, '0').toUpperCase();

  return `#${redHex}${greenHex}${blueHex}`;
};
